import MainLayout from '@/pages/Layout/MainLayout.vue'
const myfiles = () => import('@/pages/myfiles/FileStore.vue')

export default {
  path: '/files',
  redirect: '/files/store',
  component: MainLayout,
  children: [
    {
      path: 'store',
      component: myfiles,
      meta: {
        title: 'Мои файлы',  
      }
    },
  ]
}
